import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import useNotifications from './useNotifications'

export default function useCmisReferences({ getCmisReferences, id, context }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [references, setReferences] = useState()

  useEffect(() => {
    if (id) {
      getCmisReferences({ id, context })
        .then((resp) => {
          if (resp.status === 200) {
            setReferences(resp.data)
          }
          if (resp.data.notifications?.length > 0) {
            error(
              `${t(`hooks.errors.${resp.data.notifications[0].title}`, resp.data.notifications[0].title)}: ${
                resp.data.notifications[0].msg
              }`
            )
          }
        })
        .catch((err) => {
          error(
            t('hooks.errors.gettingCmisReferences', {
              defaultValue: `Error getting CMIS references: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
  }, [context, error, getCmisReferences, id, t])

  return { references }
}
